import type { FC } from "react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



const Footer: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerHeight = 64; // 4rem = 64px
        const elementPosition = element.offsetTop - headerHeight;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const navigateToPage = (path: string) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 100);
  };
  
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between">
          <div className="w-full lg:w-1/3 mb-6 lg:mb-0">
            <h2 className="text-lg font-bold mb-2">TOM Robotics</h2>
            <p className="text-gray-400">
              {t('footer.tagline')}
            </p>
          </div>
          <div className="w-full lg:w-2/3">
            <div className="flex flex-wrap justify-end">
              <div className="w-full lg:w-1/3">
                <h2 className="text-md font-semibold mb-2">{t('footer.navigate')}</h2>
                <div className="flex flex-col lg:flex-row">
                  <ul className="space-y-2 w-full lg:w-1/2">
                    <li>
                      <button
                        onClick={() => scrollToSection('hero')}
                        className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                      >
                        <span className="relative z-10">{t('footer.home')}</span>
                        <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => scrollToSection('technology')}
                        className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                      >
                        <span className="relative z-10">{t('nav.technology')}</span>
                        <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => scrollToSection('products')}
                        className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                      >
                        <span className="relative z-10">{t('nav.products')}</span>
                        <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => scrollToSection('research')}
                        className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                      >
                        <span className="relative z-10">{t('nav.research')}</span>
                        <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                      </button>
                    </li>
                  </ul>
                  <ul className="space-y-2 w-full lg:w-1/2">
                    <li>
                      <button
                        onClick={() => scrollToSection('about')}
                        className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                      >
                        <span className="relative z-10">{t('nav.about')}</span>
                        <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => scrollToSection('team')}
                        className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                      >
                        <span className="relative z-10">{t('team.title')}</span>
                        <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => scrollToSection('career')}
                        className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                      >
                        <span className="relative z-10">{t('nav.career')}</span>
                        <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => scrollToSection('contact')}
                        className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                      >
                        <span className="relative z-10">{t('nav.contact')}</span>
                        <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="w-full lg:w-1/3">
                <h2 className="text-md font-semibold mb-2">{t('footer.legal')}</h2>
                <ul className="space-y-2">
                  <li>
                    <button
                      onClick={() => navigateToPage('/impressum')}
                      className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                    >
                      <span className="relative z-10">{t('footer.impressum')}</span>
                      <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigateToPage('/univais')}
                      className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                    >
                      <span className="relative z-10">{t('footer.univaisPage')}</span>
                      <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigateToPage('/univais/datenschutz')}
                      className="relative text-gray-400 hover:text-white transition-all duration-300 text-left group py-1 transform hover:translate-x-1"
                    >
                      <span className="relative z-10">{t('footer.univaisPrivacy')}</span>
                      <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                    </button>
                  </li>
                </ul>
              </div>
              <div className="w-full lg:w-1/3">
                <h2 className="text-md font-semibold mb-2">{t('footer.connect')}</h2>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="mailto:contact@tomrobotics.at"
                      className="relative text-gray-400 hover:text-white transition-all duration-300 group py-1 transform hover:translate-x-1 inline-block"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="relative z-10">{t('footer.email')}</span>
                      <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/thomas-strasser-krauss-23070a27/"
                      className="relative text-gray-400 hover:text-white transition-all duration-300 group py-1 transform hover:translate-x-1 inline-block"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="relative z-10">{t('footer.linkedin')}</span>
                      <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/tom.robotics/"
                      className="relative text-gray-400 hover:text-white transition-all duration-300 group py-1 transform hover:translate-x-1 inline-block"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="relative z-10">{t('footer.instagram')}</span>
                      <div className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary-blue group-hover:w-full transition-all duration-300"></div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-700 pt-4 text-center text-gray-500">
          <p>&copy; {new Date().getFullYear()} TOM Robotics GmbH. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;